import type { LinkTypes } from 'fitify-ui-landing/src/@types'

export const navigationData: LinkTypes.Navigation[] = []
